import { render, staticRenderFns } from "./PartnerSalesIframe.vue?vue&type=template&id=49491f6a&"
import script from "./PartnerSalesIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerSalesIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports